<template>
  <div class="field__Group" :class="{ isInline, isError }">
    <label class="field__GroupLabel form__Label" v-if="label" v-html="label" />
    <div :class="isInline ? 'form__Row' : 'form__Column'">
      <slot />
    </div>
    <FormError :errors="mergedErrors" className="field__GroupError" />
    <span class="field__GroupInfo form__Info" v-if="info" v-html="info" />
  </div>
</template>

<script setup>
  const props = defineProps(useFormFieldProps())

  const { mergedErrors, isInline, isError } = useFormField(props)
</script>
